import React from 'react';
import { ISpruceFieldProps, SpruceField } from '../../../components/SpruceField';
import { AreaInput } from '../../../components/AreaInput';

interface ICancelOrderProps {
  fieldName: string;
  placeholder?: string;
  label?: string;
}

export const CancelOrderReasonInput: React.FC<ICancelOrderProps> = ({ fieldName, placeholder, label }) => {
  const reasonText = (numberOfCharacters: number) => `${numberOfCharacters}/50 Characters Remaining`;
  return (
    <SpruceField name={fieldName}>
      {({ field }: ISpruceFieldProps) => (
        <AreaInput
          value={field.value}
          onChange={field.onChange}
          placeholder={placeholder || 'Cancellation Reason'}
          label={label}
          rows={1}
          hintText={field.errorText ? null : reasonText(field.value ? field.value.length : 0)}
          errorText={field.errorText ? reasonText(field.value ? field.value.length : 0) : null}
        />
      )}
    </SpruceField>
  );
};
